import { useSearchParams } from 'react-router-dom';
import { useSync } from '../sync/SyncProvider';
import { usePos } from '../pos/PosProvider';
import { TransactionsTable } from '../components/TransactionsTable';
import { PlusIcon, RefreshIcon } from '../components/icons';
import { useAuth } from '../auth/AuthProvider';

export function PedidosPage() {
  const [searchParams] = useSearchParams();
  const { openPos } = usePos();
  const { pending, online, syncing, syncNow } = useSync();
  const { demo } = useAuth();
  const initialSearch = searchParams.get('search') ?? '';

  return (
    <div className="dashboard">
      <header className="page-head">
        <div>
          <p className="eyebrow">Operaciones comerciales</p>
          <h1 className="page-title">Pedidos & Cotizaciones</h1>
          <p className="page-sub">
            Documentos capturados en ruta y en oficina, con trazabilidad de sincronización.
          </p>
        </div>
        <div className="page-head__actions">
          <button
            type="button"
            className="btn btn--outline"
            onClick={() => void syncNow()}
            disabled={syncing || !online || demo}
          >
            <RefreshIcon size={16} className={syncing ? 'spin' : undefined} />
            {syncing ? 'Sincronizando…' : `Sincronizar${pending > 0 ? ` (${pending})` : ''}`}
          </button>
          <button type="button" className="btn btn--primary" onClick={openPos}>
            <PlusIcon size={17} />
            Nuevo Pedido / POS
          </button>
        </div>
      </header>

      {pending > 0 ? (
        <div className="inline-note inline-note--warning" role="status">
          <strong>{pending} movimiento(s) en la cola local.</strong>{' '}
          {demo
            ? 'En modo demostración no se envían al servidor.'
            : online
              ? 'Pulsa Sincronizar para enviarlos ahora.'
              : 'Se enviarán automáticamente al recuperar la conexión.'}
        </div>
      ) : null}

      <TransactionsTable full initialSearch={initialSearch} />
    </div>
  );
}
